export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground">{title}</h1>
        {actions && <div className="flex flex-wrap items-center gap-2 max-w-full">{actions}</div>}
      </div>
      {subtitle && <p className="text-sm text-muted-foreground mt-1 w-full">{subtitle}</p>}
    </div>
  );
}
